// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"23":"ad3e1a73e4b38200","296":"f779c35deb1e08b2","734":"e6940c4ae9b1c8bc","915":"e5a59d38a053b60c"}[chunkId] + ".js";
};